export const InsuranceTypes = [
    {
        id: 0,
        name: "Standard insurance"
    },
    {
        id: 1,
        name: "Up to £1000"
    },
    {
        id: 2,
        name: "Up to £2000"
    },
    {
        id: 3,
        name: "Up to £3000"
    },
    {
        id: 4,
        name: "Up to £4000"
    },
    {
        id: 5,
        name: "Up to £5000"
    },
    {
        id: 6,
        name: "Up to £6000"
    },
    {
        id: 7,
        name: "Up to £7000"
    },
    {
        id: 8,
        name: "Up to £8000"
    },
    {
        id: 9,
        name: "Up to £9000"
    },
    {
        id: 10,
        name: "Up to £10000"
    },
];

export function getInsuranceType(insuranceEnum: number): string {
    const currentType = InsuranceTypes.find(i => i.id === insuranceEnum);
    return currentType ? currentType.name : '';
}
